import _ from 'lodash';
import React, { useState, Fragment } from 'react';
import { Dialog as Dialog$1, DialogTitle, DialogContent, Box, CircularProgress, DialogContentText, DialogActions, Button, Grid, Typography, TextField, TableContainer, Table, TableHead, TableRow, TableCell, TableSortLabel, TableBody, List, ListItem, Alert, IconButton, Collapse, ListItemText, AppBar, Drawer, Container, ListItemButton, ListItemIcon, Divider, Toolbar } from '@mui/material';
import { Search, Close, ExpandLess, ExpandMore, ExitToApp, Menu } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import deLocale from 'date-fns/locale/de';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var Dialog = function Dialog(_ref) {
  var close = _ref.close,
      loading = _ref.loading,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 'sm' : _ref$maxWidth,
      no = _ref.no,
      _ref$noText = _ref.noText,
      noText = _ref$noText === void 0 ? 'Nein' : _ref$noText,
      ok = _ref.ok,
      _ref$okText = _ref.okText,
      okText = _ref$okText === void 0 ? 'Ok' : _ref$okText,
      open = _ref.open,
      submit = _ref.submit,
      submitFormId = _ref.submitFormId,
      _ref$submitText = _ref.submitText,
      submitText = _ref$submitText === void 0 ? 'Speichern' : _ref$submitText,
      text = _ref.text,
      title = _ref.title,
      yes = _ref.yes,
      _ref$yesText = _ref.yesText,
      yesText = _ref$yesText === void 0 ? 'Ja' : _ref$yesText;
  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: close,
    maxWidth: maxWidth
  }, title ? /*#__PURE__*/React.createElement(DialogTitle, null, title) : null, /*#__PURE__*/React.createElement(DialogContent, null, loading ? /*#__PURE__*/React.createElement(Box, {
    sx: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(CircularProgress, null)) : null, text ? typeof text == "string" ? /*#__PURE__*/React.createElement(DialogContentText, null, loading ? /*#__PURE__*/React.createElement("br", null) : null, text) : text : null), yes || no || ok || submit ? /*#__PURE__*/React.createElement(DialogActions, null, yes ? /*#__PURE__*/React.createElement(Button, {
    onClick: yes,
    color: "primary"
  }, yesText) : null, no ? /*#__PURE__*/React.createElement(Button, {
    onClick: no,
    color: "primary"
  }, noText) : null, ok ? /*#__PURE__*/React.createElement(Button, {
    onClick: ok,
    color: "primary"
  }, okText) : null, submit ? /*#__PURE__*/React.createElement(Button, {
    onClick: submit,
    type: "submit",
    form: submitFormId,
    color: "primary"
  }, submitText) : null) : null);
};

function DataList(_ref) {
  var AppLink = _ref.AppLink,
      _ref$canCreate = _ref.canCreate,
      canCreate = _ref$canCreate === void 0 ? true : _ref$canCreate,
      _ref$canDelete = _ref.canDelete,
      canDelete = _ref$canDelete === void 0 ? function (id) {
    return true;
  } : _ref$canDelete,
      _ref$canEdit = _ref.canEdit,
      canEdit = _ref$canEdit === void 0 ? function (id) {
    return true;
  } : _ref$canEdit,
      _ref$canSort = _ref.canSort,
      canSort = _ref$canSort === void 0 ? function (columnId) {
    return true;
  } : _ref$canSort,
      columns = _ref.columns,
      createAs = _ref.createAs,
      createHref = _ref.createHref,
      createText = _ref.createText,
      deleteAction = _ref.deleteAction,
      deleteConfirmationText = _ref.deleteConfirmationText,
      deleteConfirmationTitle = _ref.deleteConfirmationTitle,
      deleted = _ref.deleted,
      deleteLoadingText = _ref.deleteLoadingText,
      deleteSuccessText = _ref.deleteSuccessText,
      deleteSuccessTitle = _ref.deleteSuccessTitle,
      detailsAs = _ref.detailsAs,
      detailsHref = _ref.detailsHref,
      editAs = _ref.editAs,
      editHref = _ref.editHref,
      emptyMessage = _ref.emptyMessage,
      filterRows = _ref.filterRows,
      _ref$filterSection = _ref.filterSection,
      filterSection = _ref$filterSection === void 0 ? null : _ref$filterSection,
      onCloseDeleteSuccess = _ref.onCloseDeleteSuccess,
      onRowClick = _ref.onRowClick,
      rowAlignment = _ref.rowAlignment,
      rowMaxWidth = _ref.rowMaxWidth,
      rows = _ref.rows,
      _ref$saveSearchText = _ref.saveSearchText,
      saveSearchText = _ref$saveSearchText === void 0 ? function (searchText) {} : _ref$saveSearchText,
      _ref$searchTextQuery = _ref.searchTextQuery,
      searchTextQuery = _ref$searchTextQuery === void 0 ? "" : _ref$searchTextQuery,
      sendButtonFunction = _ref.sendButtonFunction,
      sendButtonLoadingText = _ref.sendButtonLoadingText,
      sendButtonText = _ref.sendButtonText,
      _ref$sort = _ref.sort,
      sort = _ref$sort === void 0 ? function (row, i) {
    return row[i];
  } : _ref$sort,
      _ref$striped = _ref.striped,
      striped = _ref$striped === void 0 ? false : _ref$striped,
      title = _ref.title;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      deleteId = _useState2[0],
      setDeleteId = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showDeleteConfirmation = _useState4[0],
      setShowDeleteConfirmation = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showDeleteLoading = _useState6[0],
      setShowDeleteLoading = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showDeleteSuccess = _useState8[0],
      setShowDeleteSuccess = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      sendButtonLoading = _useState10[0],
      setSendButtonLoading = _useState10[1];

  var _useState11 = useState(searchTextQuery),
      _useState12 = _slicedToArray(_useState11, 2),
      searchText = _useState12[0],
      setSearchText = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      order = _useState14[0],
      setOrder = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      orderBy = _useState16[0],
      setOrderBy = _useState16[1];

  var filteredRows = filterRows ? filterRows(rows) : rows;

  if (searchText) {
    filteredRows = _.filter(filteredRows, function (row) {
      return _.some(row, function (entry) {
        var entryValue = entry === null ? null : _typeof(entry) === 'object' ? entry.props.searchKey : entry;
        return !!entryValue && entryValue.toString().toLowerCase().includes(searchText.toLowerCase());
      });
    });
  }

  var sortedRows = orderBy != null ? order === 'desc' ? _.sortBy(filteredRows, function (row) {
    return sort(row, orderBy);
  }).reverse() : _.sortBy(filteredRows, function (row) {
    return sort(row, orderBy);
  }) : filteredRows;

  var handleRowClick = function handleRowClick(e, id) {
    if ((e.target.nodeName === 'TD' || e.target.nodeName === "DIV") && !!onRowClick) {
      onRowClick(id);
    }
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, title ? /*#__PURE__*/React.createElement(Typography, {
    variant: "h2",
    lang: "de",
    sx: {
      marginBottom: '10px',
      overflowWrap: 'break-word',
      hyphens: 'auto'
    }
  }, title) : null), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    direction: "row-reverse"
  }, !sendButtonText ? null : /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: "auto"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      "float": 'right',
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    disabled: sendButtonLoading,
    onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSendButtonLoading(true);
              _context.next = 3;
              return sendButtonFunction();

            case 3:
              setSendButtonLoading(false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))
  }, sendButtonText))), !createHref ? null : /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: "auto"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      "float": 'right',
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  }, canCreate ? /*#__PURE__*/React.createElement(AppLink, {
    href: createHref,
    as: createAs || undefined
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary"
  }, createText)) : /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: true
  }, createText))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: "auto"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      "float": 'right',
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Search, null), /*#__PURE__*/React.createElement(TextField, {
    label: "Suche",
    onChange: function onChange(e) {
      setSearchText(e.target.value);
      saveSearchText(e.target.value);
    },
    size: "small",
    value: searchText,
    variant: "outlined"
  })))), filterSection ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, filterSection) : null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TableContainer, {
    style: {
      maxHeight: sortedRows.length ? '600px' : null,
      marginBottom: '100px'
    }
  }, /*#__PURE__*/React.createElement(Table, {
    stickyHeader: true
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, _.map(columns, function (column, i) {
    return /*#__PURE__*/React.createElement(TableCell, {
      key: column,
      sx: {
        backgroundColor: 'primary.main',
        color: 'white'
      }
    }, canSort(i) ? /*#__PURE__*/React.createElement(TableSortLabel, {
      active: orderBy === i,
      direction: orderBy === i ? order : 'asc',
      onClick: function onClick() {
        var newOrder = orderBy === i ? order === 'asc' ? 'desc' : 'asc' : 'asc';
        setOrder(newOrder);
        setOrderBy(i);
      },
      style: {
        color: 'white'
      }
    }, column) : column);
  }), !editHref && !deleteAction && !detailsHref ? null : /*#__PURE__*/React.createElement(TableCell, {
    sx: {
      backgroundColor: 'primary.main'
    }
  }))), /*#__PURE__*/React.createElement(TableBody, null, _.map(sortedRows, function (row, i) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: row[row.length - 1],
      onClick: function onClick(e) {
        return handleRowClick(e, row[row.length - 1]);
      },
      sx: {
        backgroundColor: i % 2 && striped ? 'secondary.main' : 'white'
      }
    }, _.map(row, function (propertyValue, i) {
      return i === row.length - 1 ? null : /*#__PURE__*/React.createElement(TableCell, {
        key: i,
        sx: {
          textAlign: rowAlignment ? rowAlignment[i] : 'left',
          maxWidth: rowMaxWidth ? rowMaxWidth[i] : 'none'
        }
      }, propertyValue);
    }), !editHref && !deleteAction && !detailsHref ? null : /*#__PURE__*/React.createElement(TableCell, {
      sx: {
        textAlign: 'right'
      }
    }, !editHref || !canEdit(row[row.length - 1]) ? null : /*#__PURE__*/React.createElement(AppLink, {
      href: editHref,
      as: !editAs ? undefined : editAs(row[row.length - 1])
    }, /*#__PURE__*/React.createElement(Button, null, "Bearbeiten")), !deleteAction || !canDelete(row[row.length - 1]) ? null : /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        setDeleteId(row[row.length - 1]);
        setShowDeleteConfirmation(true);
      }
    }, "L\xF6schen"), !detailsHref ? null : /*#__PURE__*/React.createElement(AppLink, {
      href: detailsHref,
      as: !detailsAs ? undefined : detailsAs(row[row.length - 1])
    }, /*#__PURE__*/React.createElement(Button, null, "Details"))));
  }), sortedRows.length ? null : /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    colSpan: columns.length + 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, emptyMessage))))))), /*#__PURE__*/React.createElement(Dialog, {
    open: showDeleteConfirmation,
    title: deleteConfirmationTitle,
    text: deleteConfirmationText,
    yes: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var deleteResponse;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setShowDeleteConfirmation(false);
              setShowDeleteLoading(true);
              _context2.next = 4;
              return deleteAction(deleteId);

            case 4:
              deleteResponse = _context2.sent;
              setShowDeleteLoading(false);
              setShowDeleteSuccess(true);
              if (deleted) deleted(deleteResponse);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })),
    no: function no() {
      return setShowDeleteConfirmation(false);
    }
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: showDeleteLoading,
    loading: true,
    text: deleteLoadingText
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: showDeleteSuccess,
    close: function close() {
      return setShowDeleteSuccess(false);
    },
    title: deleteSuccessTitle,
    text: deleteSuccessText,
    ok: function ok() {
      setShowDeleteSuccess(false);
      if (onCloseDeleteSuccess) onCloseDeleteSuccess();
    }
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: sendButtonLoading,
    text: sendButtonLoadingText
  }));
}

var DialogForm = function DialogForm(_ref) {
  var cancel = _ref.cancel,
      cancelButtonText = _ref.cancelButtonText,
      formFields = _ref.formFields,
      _ref$getErrors = _ref.getErrors,
      getErrors = _ref$getErrors === void 0 ? function () {
    return [];
  } : _ref$getErrors,
      isLoading = _ref.isLoading,
      _onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      open = _ref.open,
      _ref$submitButtonText = _ref.submitButtonText,
      submitButtonText = _ref$submitButtonText === void 0 ? 'Speichern' : _ref$submitButtonText,
      title = _ref.title;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2);
      _useState4[0];
      _useState4[1];

  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: function onClose() {
      setErrors([]);

      _onClose();
    },
    fullWidth: true
  }, title ? /*#__PURE__*/React.createElement(DialogTitle, null, title) : null, /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("form", {
    id: "dialogForm",
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        var formErrors;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                formErrors = getErrors();

                if (!(!!formErrors && formErrors.length > 0)) {
                  _context.next = 5;
                  break;
                }

                setErrors(formErrors);
                return _context.abrupt("return");

              case 5:
                _context.next = 7;
                return onSubmit();

              case 7:
                setErrors([]);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }()
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    sx: {
      paddingTop: '16px'
    }
  }, _.map(formFields, function (field, i) {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      key: i
    }, field);
  }))), /*#__PURE__*/React.createElement(List, {
    sx: {
      color: 'red'
    }
  }, _.map(errors, function (error) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: error
    }, /*#__PURE__*/React.createElement(Alert, {
      severity: "error"
    }, error));
  }))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(LoadingButton, {
    type: "submit",
    form: "dialogForm",
    loading: isLoading,
    autoFocus: true
  }, submitButtonText), cancel ? /*#__PURE__*/React.createElement(Button, {
    onClick: cancel,
    color: "primary",
    autoFocus: true
  }, cancelButtonText) : null));
};

var HelpDialog = function HelpDialog(_ref) {
  var close = _ref.close,
      open = _ref.open,
      supportUrl = _ref.supportUrl;
  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: close,
    maxWidth: false
  }, /*#__PURE__*/React.createElement(DialogTitle, null, "Hilfe", /*#__PURE__*/React.createElement(IconButton, {
    sx: {
      "float": 'right',
      padding: 0
    },
    onClick: close
  }, /*#__PURE__*/React.createElement(Close, null))), /*#__PURE__*/React.createElement(DialogContent, {
    sx: {
      width: {
        xs: 'auto',
        sm: '60vw'
      },
      height: '80vh'
    }
  }, /*#__PURE__*/React.createElement("iframe", {
    src: supportUrl,
    frameBorder: "0",
    width: "100%",
    height: "95%"
  })));
};

function Page(_ref) {
  var children = _ref.children,
      _ref$drawerWidth = _ref.drawerWidth,
      drawerWidth = _ref$drawerWidth === void 0 ? 245 : _ref$drawerWidth,
      _ref$Footer = _ref.Footer,
      Footer = _ref$Footer === void 0 ? Fragment : _ref$Footer,
      _ref$imgAlt = _ref.imgAlt,
      imgAlt = _ref$imgAlt === void 0 ? 'Logo' : _ref$imgAlt,
      _ref$imgMaxWidth = _ref.imgMaxWidth,
      imgMaxWidth = _ref$imgMaxWidth === void 0 ? {
    xs: '100px',
    sm: '160px'
  } : _ref$imgMaxWidth,
      _ref$imgPadding = _ref.imgPadding,
      imgPadding = _ref$imgPadding === void 0 ? {} : _ref$imgPadding,
      _ref$imgSrc = _ref.imgSrc,
      imgSrc = _ref$imgSrc === void 0 ? '' : _ref$imgSrc,
      _ref$Link = _ref.Link,
      Link = _ref$Link === void 0 ? Fragment : _ref$Link,
      _ref$mainMenuLinks = _ref.mainMenuLinks,
      mainMenuLinks = _ref$mainMenuLinks === void 0 ? [] : _ref$mainMenuLinks,
      _ref$me = _ref.me,
      me = _ref$me === void 0 ? {} : _ref$me,
      _ref$secondaryMenuLin = _ref.secondaryMenuLinks,
      secondaryMenuLinks = _ref$secondaryMenuLin === void 0 ? [] : _ref$secondaryMenuLin,
      _ref$showFooter = _ref.showFooter,
      showFooter = _ref$showFooter === void 0 ? false : _ref$showFooter,
      _ref$showLogin = _ref.showLogin,
      showLogin = _ref$showLogin === void 0 ? false : _ref$showLogin,
      _ref$showNav = _ref.showNav,
      showNav = _ref$showNav === void 0 ? true : _ref$showNav,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showDrawer = _useState2[0],
      setShowDrawer = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      openCollapse = _useState4[0],
      setOpenCollapse = _useState4[1];

  var theme = createTheme({
    palette: {
      primary: {
        main: '#046FA5'
      },
      secondary: {
        main: '#95BCE5'
      },
      tertiary: {
        main: '#D2E3F6'
      }
    }
  });

  var selectedByPath = function selectedByPath(href) {
    var pathname = window.location.pathname;
    return pathname === href || pathname.startsWith(href + '/');
  };

  var ListItemLinkNormal = function ListItemLinkNormal(_ref2) {
    var Icon = _ref2.Icon,
        text = _ref2.text,
        href = _ref2.href,
        style = _ref2.style;
    return /*#__PURE__*/React.createElement(ListItemButton, {
      component: Link,
      href: href,
      selected: selectedByPath(href),
      sx: style,
      onClick: function onClick() {
        return setShowDrawer(false);
      }
    }, Icon ? /*#__PURE__*/React.createElement(ListItemIcon, {
      sx: {
        color: 'primary.main',
        '& .MuiSvgIcon-root': {
          fontSize: '24px'
        }
      }
    }, Icon) : null, /*#__PURE__*/React.createElement(ListItemText, {
      primary: text,
      sx: {
        '.MuiListItemText-primary': {
          fontSize: '16px'
        }
      }
    }));
  };

  var ListItemLinkSmall = function ListItemLinkSmall(_ref3) {
    var Icon = _ref3.Icon,
        text = _ref3.text,
        href = _ref3.href;
    return /*#__PURE__*/React.createElement(ListItemButton, {
      component: Link,
      href: href,
      selected: selectedByPath(href),
      onClick: function onClick() {
        return setShowDrawer(false);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, {
      sx: {
        color: 'primary.main',
        '& .MuiSvgIcon-root': {
          fontSize: '20px'
        }
      }
    }, Icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: text,
      sx: {
        '.MuiListItemText-primary': {
          fontSize: '14.4px'
        }
      }
    }));
  };

  var ListItemButtonNormal = function ListItemButtonNormal(_ref4) {
    var Icon = _ref4.Icon,
        text = _ref4.text,
        _ref4$selected = _ref4.selected,
        selected = _ref4$selected === void 0 ? false : _ref4$selected,
        onClick = _ref4.onClick,
        _ref4$additionalIcon = _ref4.additionalIcon,
        additionalIcon = _ref4$additionalIcon === void 0 ? null : _ref4$additionalIcon;
    return /*#__PURE__*/React.createElement(ListItemButton, {
      selected: selected,
      onClick: onClick
    }, /*#__PURE__*/React.createElement(ListItemIcon, {
      sx: {
        color: 'primary.main',
        '& .MuiSvgIcon-root': {
          fontSize: '24px'
        }
      }
    }, Icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: text,
      sx: {
        '.MuiListItemText-primary': {
          fontSize: '16px'
        }
      }
    }), additionalIcon);
  };

  var ListItemButtonSmall = function ListItemButtonSmall(_ref5) {
    var Icon = _ref5.Icon,
        text = _ref5.text,
        selected = _ref5.selected,
        onClick = _ref5.onClick;
    return /*#__PURE__*/React.createElement(ListItemButton, {
      selected: selected,
      onClick: onClick
    }, /*#__PURE__*/React.createElement(ListItemIcon, {
      sx: {
        color: 'primary.main',
        '& .MuiSvgIcon-root': {
          fontSize: '20px'
        }
      }
    }, Icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: text,
      sx: {
        '.MuiListItemText-primary': {
          fontSize: '14.4px'
        }
      }
    }));
  };

  var ListCustom = function ListCustom(_ref6) {
    var children = _ref6.children;
    return /*#__PURE__*/React.createElement(List, {
      sx: {
        '.Mui-selected.MuiListItemButton-root': {
          bgcolor: 'secondary.main'
        },
        '& .Mui-selected': {
          '.MuiListItemText-primary': {
            fontWeight: 'bold'
          }
        }
      }
    }, children);
  };

  var DividerCustom = function DividerCustom(_ref7) {
    var additionalStyle = _ref7.additionalStyle;
    return /*#__PURE__*/React.createElement(Divider, {
      sx: _objectSpread2({
        backgroundColor: 'primary.main'
      }, additionalStyle),
      variant: "middle"
    });
  };

  var ToolbarCustom = function ToolbarCustom(_ref8) {
    var children = _ref8.children;
    return /*#__PURE__*/React.createElement(Toolbar, {
      style: {
        paddingRight: 0,
        minHeight: '40px'
      }
    }, children);
  };

  var drawerList = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ToolbarCustom, null), " ", /*#__PURE__*/React.createElement(ListCustom, null, _.map(mainMenuLinks, function (_ref9) {
    var href = _ref9.href,
        text = _ref9.text,
        icon = _ref9.icon,
        _ref9$type = _ref9.type,
        type = _ref9$type === void 0 ? 'normal' : _ref9$type,
        subItems = _ref9.subItems;

    var collapseSelected = type === 'collapse' && _.some(subItems, function (subItem) {
      return selectedByPath(subItem.href);
    });

    return type === 'normal' ? /*#__PURE__*/React.createElement(ListItemLinkNormal, {
      key: href,
      Icon: icon,
      text: text,
      href: href
    }) : type === 'collapse' ? /*#__PURE__*/React.createElement(Fragment, {
      key: text
    }, /*#__PURE__*/React.createElement(ListItemButtonNormal, {
      selected: collapseSelected,
      onClick: function onClick() {
        return setOpenCollapse(openCollapse === text ? null : text);
      },
      Icon: icon,
      text: text,
      additionalIcon: openCollapse === text ? /*#__PURE__*/React.createElement(ExpandLess, null) : /*#__PURE__*/React.createElement(ExpandMore, null)
    }), /*#__PURE__*/React.createElement(Collapse, {
      "in": openCollapse === text,
      timeout: "auto"
    }, /*#__PURE__*/React.createElement(List, {
      disablePadding: true
    }, _.map(subItems, function (_ref10) {
      var href = _ref10.href,
          text = _ref10.text,
          icon = _ref10.icon;
      return /*#__PURE__*/React.createElement(ListItemLinkNormal, {
        key: href,
        Icon: icon,
        text: text,
        href: href,
        style: {
          pl: 4
        }
      });
    })))) : null;
  })), /*#__PURE__*/React.createElement(DividerCustom, {
    additionalStyle: {
      marginTop: 'auto'
    }
  }), me ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListCustom, null, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(ListItemText, {
    sx: {
      '.MuiListItemText-primary': {
        fontSize: '14.4px'
      }
    }
  }, me.firstName + ' ' + me.lastName, " "))), /*#__PURE__*/React.createElement(DividerCustom, null)) : null, secondaryMenuLinks.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListCustom, null, _.map(secondaryMenuLinks, function (_ref11) {
    var type = _ref11.type,
        selected = _ref11.selected,
        onClick = _ref11.onClick,
        Icon = _ref11.Icon,
        text = _ref11.text,
        href = _ref11.href;
    return type === 'button' ? /*#__PURE__*/React.createElement(ListItemButtonSmall, {
      Icon: Icon,
      text: text,
      selected: selected,
      onClick: onClick,
      key: text
    }) : type === 'link' ? /*#__PURE__*/React.createElement(ListItemLinkSmall, {
      Icon: Icon,
      text: text,
      href: href,
      key: text
    }) : null;
  })), /*#__PURE__*/React.createElement(DividerCustom, null)) : null, /*#__PURE__*/React.createElement(ListCustom, null, /*#__PURE__*/React.createElement(ListItemLinkSmall, {
    Icon: /*#__PURE__*/React.createElement(ExitToApp, null),
    text: "Logout",
    href: "/logout"
  })));
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, showNav ? /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement(AppBar, {
    position: "fixed",
    sx: {
      zIndex: function zIndex(theme) {
        return theme.zIndex.drawer + 1;
      }
    }
  }, /*#__PURE__*/React.createElement(ToolbarCustom, null, /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    onClick: function onClick() {
      return setShowDrawer(!showDrawer);
    },
    sx: {
      display: {
        md: 'none'
      },
      '& .MuiSvgIcon-root': {
        fontSize: '24px'
      }
    }
  }, /*#__PURE__*/React.createElement(Menu, null)), title ? /*#__PURE__*/React.createElement(Box, {
    sx: {
      ml: '5px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: {
        xs: '12.8px',
        sm: '17.6px'
      }
    }
  }, title)) : null, /*#__PURE__*/React.createElement(Box, {
    sx: {
      height: 0,
      width: {
        xs: '100px',
        sm: '160px'
      },
      borderBottom: '40px solid white',
      borderLeft: '40px solid transparent',
      marginLeft: 'auto'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    component: "img",
    src: imgSrc,
    alt: imgAlt,
    sx: {
      maxWidth: imgMaxWidth,
      maxHeight: '40px',
      "float": 'right',
      padding: imgPadding
    }
  })))), /*#__PURE__*/React.createElement(Box, {
    component: "nav",
    sx: {
      width: {
        md: drawerWidth
      }
    }
  }, /*#__PURE__*/React.createElement(Drawer, {
    variant: "temporary",
    open: showDrawer,
    onClose: function onClose() {
      return setShowDrawer(!showDrawer);
    },
    sx: {
      display: {
        xs: 'block',
        md: 'none'
      },
      '& .MuiDrawer-paper': {
        width: drawerWidth,
        backgroundColor: 'tertiary.main',
        color: 'primary.main'
      }
    }
  }, drawerList), /*#__PURE__*/React.createElement(Drawer, {
    variant: "permanent",
    open: true,
    sx: {
      display: {
        xs: 'none',
        md: 'block'
      },
      '& .MuiDrawer-paper': {
        width: drawerWidth,
        backgroundColor: 'tertiary.main',
        color: 'primary.main'
      }
    }
  }, drawerList)), /*#__PURE__*/React.createElement(Box, {
    component: "main",
    sx: {
      flexGrow: 1,
      width: {
        md: "calc(100% - ".concat(drawerWidth, "px)"),
        xs: '100%'
      }
    }
  }, /*#__PURE__*/React.createElement(ToolbarCustom, null), " ", /*#__PURE__*/React.createElement(Container, {
    maxWidth: "xl",
    sx: {
      pt: '30px'
    }
  }, /*#__PURE__*/React.createElement(LocalizationProvider, {
    dateAdapter: AdapterDateFns,
    adapterLocale: deLocale
  }, children)), showFooter ? /*#__PURE__*/React.createElement(Footer, null) : null)) : /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement(AppBar, {
    position: "fixed"
  }, /*#__PURE__*/React.createElement(ToolbarCustom, null, showLogin ? /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Button, {
    color: "inherit",
    component: Link,
    href: "/login",
    sx: {
      textTransform: 'none',
      fontSize: '16px',
      '&:hover': {
        color: 'white'
      }
    }
  }, "Login")) : null, title && !showLogin ? /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: {
        xs: '12.8px',
        sm: '17.6px'
      }
    }
  }, title)) : null, /*#__PURE__*/React.createElement(Box, {
    sx: {
      height: 0,
      width: {
        xs: '100px',
        sm: '160px'
      },
      borderBottom: '40px solid white',
      borderLeft: '40px solid transparent',
      marginLeft: 'auto'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    component: "img",
    src: imgSrc,
    alt: imgAlt,
    sx: {
      maxWidth: imgMaxWidth,
      maxHeight: '40px',
      "float": 'right',
      padding: imgPadding
    }
  })))), /*#__PURE__*/React.createElement(Box, {
    component: "main",
    sx: {
      flexGrow: 1,
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(ToolbarCustom, null), " ", /*#__PURE__*/React.createElement(Container, {
    maxWidth: "xl",
    sx: {
      pt: '30px'
    }
  }, /*#__PURE__*/React.createElement(LocalizationProvider, {
    dateAdapter: AdapterDateFns,
    locale: deLocale
  }, children)), showFooter ? /*#__PURE__*/React.createElement(Footer, null) : null)));
}

export { DataList, Dialog, DialogForm, HelpDialog, Page };
